define('app/services.js',[], function() { 
    
    var services = {};

    services.dataService = function($http, $q) {

		//this.app = qlik.openApp('Euronews - Mortality Data.qvf', config);
		this.app = qlik.openApp('05acb764-5f04-4350-ae26-f6518e10ab0b', config);
        //window.app = this.app;
		
	};
    services.dataService.$inject = ['$http', '$q'];

    return services;
});
